import { useTranslate } from '@tolgee/react'
import { ColoredLabel } from '@tom-ui/ui'

export const IssuesToResolveChip = () => {
  const { t } = useTranslate()

  return (
    <ColoredLabel
      label={t('issuesToResolve', 'Issues to resolve')}
      color='warning'
      sx={{
        width: 'fit-content',
      }}
    />
  )
}
